import { render, staticRenderFns } from "./MessageEditor.vue?vue&type=template&id=e7d78d9c&scoped=true&"
import script from "./MessageEditor.vue?vue&type=script&lang=js&"
export * from "./MessageEditor.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditor.vue?vue&type=style&index=0&id=e7d78d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d78d9c",
  null
  
)

export default component.exports